export default "__VITE_ASSET__8GpFRvlS__"